// Dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";

// App components
import LoginPage from './pages/login/LoginPage';
import RegisterPage from './pages/register/RegisterPage'
import DashboardContainer from './pages/dashboard/containers/DashboardContainer'
import LogoutPage from './pages/logout/LogoutPage';
import reportWebVitals from './reportWebVitals';

// Styles
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        <Route path="/dashboard/*" element={<DashboardContainer />}>
          <Route path="courses" element={<DashboardContainer />} />
          <Route path="account" element={<DashboardContainer />} />
          <Route path="help" element={<DashboardContainer />} />
          <Route path="add-new-course" element={<DashboardContainer />} />
          <Route path="users" element={<DashboardContainer />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
